@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';

.cost-review-link {
  font-size: 14px;
  color: @fulfillment-planner--cost-review-link--text-color;
  padding-left: 10px;
}
